import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  NgZone,
} from "@angular/core";

import { ScriptLoaderService } from "../../../../../app/_services/script-loader.service";
import { appService } from "../../../../../app/_services/app.service";
import { CommonService } from "../../../../../app/_services/common.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import {
  ChartsModule,
  BaseChartDirective,
} from "../../../../../../node_modules/ng2-charts";
import { bind1 } from "@angular/core/src/render3/instructions";
//@ts-ignore
import * as am4core from "@amcharts/amcharts4/core";
//@ts-ignore
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { ThrowStmt } from "@angular/compiler";
import { NavService } from "../../../../_services/NavService.service";
import { environment } from "../../../../../environments/environment";
import { Router } from "@angular/router";
import { Helpers } from "../../../../../app/helpers";
import { TranslateConfigService } from "../../../home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
const LNG_KEY = "SELECTED_LANGUAGE";

am4core.useTheme(am4themes_animated);

declare var $: any;
declare var Chart: any;
declare var jQuery: any;
declare var SBReportAPI: any;

@Component({
  selector: "app-blank",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit {
  selectedLang: string;
  private amchart: am4charts.XYChart;
  //order conversion ratio
  orders: any = 0;
  booked: any = 0;
  percent: any = 0;
  data: any;
  OrderToBookingRatio: any;
  OrderStatus: any;
  options: any;
  DeliveryDataTAT: any = {};
  DashboardSearchData: any = [];
  CompanyId: any;

  FromDate: any;
  ToDate: any;
  Networkdatatable;
  Driverdatatable;
  Locationdatatable;
  @ViewChild(BaseChartDirective)
  public chart: any = BaseChartDirective;
  public Polarchart: any = BaseChartDirective;
  static dashbaordComponent: DashboardComponent;

  // ----------------------------------------------------------------------
  constructor(
    private _script: ScriptLoaderService,
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private cookieservice: CookieService,
    private zone: NgZone,
    private _navService: NavService,
    private router: Router,
    private service: TranslateConfigService,
    public translate: TranslateService
  ) {
    DashboardComponent.dashbaordComponent = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
    this.options = {
      legend: { display: false },
      animation: { animateRotate: true, animateScale: true },
      elements: {
        arc: {
          borderWidth: 1,
        },
      },
    };
  }

  reload() {
    window.location.reload();
  }

  ngOnInit() {
    if (
      localStorage.getItem("ChnageCompnayId") != "undefined" &&
      localStorage.getItem("ChnageCompnayId") != null &&
      localStorage.getItem("ChnageCompnayId") != ""
    ) {
      this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    }

    this.DashboardSearchData = {};
    this.DashboardSearchData.DateFilterName = "DAY";
    this.DashboardSearchData.DateFilterValue = "15";
    this.DashboardSearchData.CompanyId = this.CompanyId;
    $("#SearchDashboard").val("15-Day");
    $(function () {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: "hover",
      });
      $('[data-toggle="tooltip"]').on("click", function () {
        $(this).tooltip("hide");
      });
    });
    this.RefreshDropDown();

    setTimeout(() => {
      this._navService.navItem$.subscribe((item) => {
        this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
        // this.GetReport();
        if (this.Locationdatatable) this.Locationdatatable.destroy();
        // this.GetLocationCodeList();
      });
    }, 500);
    // this.GetTransporterList();
    // this.GetDriverList();
    // this.GetLocationCodeList();
    //this.GetReport();
  }

  GetDashboardData() {
    if ($("#SearchDashboard option:selected").val() != "") {
      this.DashboardSearchData.DateFilterValue = $(
        "#SearchDashboard option:selected"
      )
        .val()
        .split("-")[0];
      this.DashboardSearchData.DateFilterName = $(
        "#SearchDashboard option:selected"
      )
        .val()
        .split("-")[1];
    } else {
      this.DashboardSearchData.DateFilterValue = 15;
      this.DashboardSearchData.DateFilterName = "DAY";
    }
    // if (this.Networkdatatable)
    //     this.Networkdatatable.destroy();
    // this.GetTransporterList();

    // if (this.Driverdatatable)
    //     this.Driverdatatable.destroy();
    // this.GetDriverList();

    // if (this.Locationdatatable)
    //     this.Locationdatatable.destroy();
    // this.GetLocationCodeList();

    this.GetReport();
  }
  GetReport() {
    Helpers.setLoading(true);
    this.DashboardSearchData.CompanyId = this.CompanyId;
    this._appService
      .Post("Dashboard", "GetDashboardData", this.DashboardSearchData)
      .subscribe(
        (response) => {
          // Order Conversion Ratio
          this.orders = response.OrderConverionRatio.Orders;
          this.booked = response.OrderConverionRatio.Converted;
          this.percent = (this.booked / this.orders) * 100;

          //Order Status

          var labels = response.OrderStatus.map((s) => s.StatusName);
          var data = response.OrderStatus.map((s) => s.StatusCount);
          this.GetOrderStatusChart(labels, data);

          //Vehicle Size
          var labels = response.VehicleTypeWiseCount.map((s) => s.VehicleType);
          var data = response.VehicleTypeWiseCount.map((s) => s.VehicleCount);
          var BgColor: any = [];
          labels.forEach((element) => {
            BgColor.push(this.Random_rgba());
          });
          this.GetVehicleSizePieChart(labels, data, BgColor);

          //Order To Booking
          var labels = response.OrderBookingRatio.map((s) => s.Lable);
          var BookingCount = response.OrderBookingRatio.map(
            (s) => s.BookingCount
          );
          var OrderCount = response.OrderBookingRatio.map((s) => s.OrderCount);
          this.GetOrderToBookingRatio(labels, BookingCount, OrderCount);

          //Delivery Data TAT
          // if (response.DeliveryDataTAT != null)
          this.DeliveryDataTAT = response.DeliveryDataTAT;

          //Origin Trip Performance
          this.GetOriginTripPerformanceChart(
            response.OriginTripPerformanceData
          );

          //Destination Trip Performance
          this.GetDestinationTripPerformanceChart(
            response.DestinationTripPerformanceData
          );
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
  }

  GetOrderStatusChart(label, data) {
    this.OrderStatus = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: ["#FFCE56", "#36A2EB", "#4ec27e", "#FF6384"],

          hoverBackgroundColor: ["#FFCE56", "#36A2EB", "#4ec27e", "#FF6384"],
        },
      ],
    };
  }

  GetVehicleSizePieChart(label, data, BgColor) {
    this.data = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: BgColor,
          hoverBackgroundColor: BgColor,
        },
      ],
    };
  }

  GetOrderToBookingRatio(label, BookingCount, OrderCount) {
    this.OrderToBookingRatio = {
      labels: label,
      datasets: [
        {
          label: "Booking",
          data: BookingCount,
          fill: false,
          borderColor: "#4bc0c0",
        },
        {
          label: "Order",
          data: OrderCount,
          fill: false,
          borderColor: "#565656",
        },
      ],
    };
  }

  GetOriginTripPerformanceChart(OriginTripData) {
    this.zone.runOutsideAngular(() => {
      if ($("#originChart").length) {
        // use this if you are using id to check
        let chart = am4core.create("originChart", am4charts.XYChart);
        chart.paddingRight = 20;
        chart.data = OriginTripData;
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "StatusName";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.labels.template.disabled = true;
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.disabled = true;
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "StatusCount";
        series.dataFields.categoryX = "StatusName";
        series.name = "StatusCount";
        series.columns.template.stroke = am4core.color("#3361f7");
        series.columns.template.fill = am4core.color("#3b67fb");
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.8;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
        this.chart = chart;
      }
    });
  }

  GetDestinationTripPerformanceChart(DestTripData) {
    this.zone.runOutsideAngular(() => {
      if ($("#destinationChart").length) {
        // use this if you are using id to check
        let chart = am4core.create("destinationChart", am4charts.XYChart);
        chart.paddingRight = 20;
        chart.data = DestTripData;
        // Create axes

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "StatusName";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.labels.template.disabled = true;
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.disabled = true;
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "StatusCount";
        series.dataFields.categoryX = "StatusName";
        series.name = "StatusCount";
        series.columns.template.stroke = am4core.color("#3361f7");
        series.columns.template.fill = am4core.color("#3b67fb");
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.8;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
        this.chart = chart;
      }
    });
  }

  Random_rgba() {
    var letters = "01234ABCD56789EF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }
  //-----------------------------------------------------------

  RefreshDropDown() {
    setTimeout(() => {
      (<any>$("#SearchDashboard")).selectpicker("refresh");
    }, 300);
  }
  //-------------------------------------------------------------

  // GetTransporterList() {
  //     this.Networkdatatable = (<any>$('.m_datatable_Transporter')).mDatatable({
  //         data: {
  //             type: "remote",
  //             source: {
  //                 read: {
  //                     method: 'POST',
  //                     url: environment.apiUrl + "api/Dashboard/GetDashboardTransporterList",
  //                     params: {
  //                         // custom parameters
  //                         CompanyId: DashboardComponent.dashbaordComponent.CompanyId,
  //                         DateFilterValue: DashboardComponent.dashbaordComponent.DashboardSearchData.DateFilterValue,
  //                         DateFilterName: DashboardComponent.dashbaordComponent.DashboardSearchData.DateFilterName
  //                     },
  //                 }
  //             },
  //             pageSize: 10,
  //             serverPaging: !0,
  //             serverFiltering: !0,
  //         },
  //         layout: {
  //             class: 'm--margin-top-5',
  //             scroll: false,
  //             footer: !1,
  //             smoothScroll: {
  //                 scrollbarShown: true
  //             }
  //         },
  //         sortable: !0,
  //         pagination: !0,
  //         toolbar: {
  //             items: {
  //                 pagination: {
  //                     pageSizeSelect: [10, 20, 30, 50, 100]
  //                 }
  //             }
  //         },
  //         search: {
  //             onChange: true,
  //             input: $('#SearchValue'),
  //             delay: 400,
  //         },
  //         rows: {
  //             afterTemplate: function (row, data, index) {
  //                 $(row).find(".btnEditNetwork").click(function () {
  //                     var Id = $(this).attr("Id");
  //                     DashboardComponent.dashbaordComponent.router.navigate(['/network', Id]);
  //                 });
  //             },
  //         },
  //         columns: [
  //             {
  //                 field: "TransporterName", width: 250, title: "Network", sortable: !1, overflow: "visible",
  //                 template: function (t) {
  //                     var btn = "";
  //                     if (DashboardComponent.dashbaordComponent.commonService.CheckHasRight("VIEW", "NETWORK_DETAILS")) {
  //                         btn = `<a id="${t.Id}" class="btnEditNetwork" style="cursor:pointer;">${t.TransporterName}</a>`;
  //                     } else {
  //                         btn = `<span id="${t.Id}">${t.TransporterName}</span>`;
  //                     }
  //                     return btn;
  //                 }
  //             },
  //             {
  //                 field: 'CreatedDate', title: "Created On", sortable: true, width: 100, textAlign: 'right'
  //             },

  //         ]
  //     });

  // }

  // GetDriverList() {
  //     this.Driverdatatable = (<any>$('.m_datatable_Driver')).mDatatable({
  //         data: {
  //             type: "remote",
  //             source: {
  //                 read: {
  //                     method: 'POST',
  //                     url: environment.apiUrl + "api/Dashboard/GetDashboardDriverList",
  //                     params: {
  //                         // custom parameters
  //                         CompanyId: DashboardComponent.dashbaordComponent.CompanyId,
  //                         DateFilterValue: DashboardComponent.dashbaordComponent.DashboardSearchData.DateFilterValue,
  //                         DateFilterName: DashboardComponent.dashbaordComponent.DashboardSearchData.DateFilterName
  //                     },
  //                 }
  //             },
  //             pageSize: 10,
  //             serverPaging: !0,
  //             serverFiltering: !0,
  //         },
  //         layout: {
  //             class: 'm--margin-top-5',
  //             scroll: false,
  //             footer: !1,
  //             smoothScroll: {
  //                 scrollbarShown: true
  //             }
  //         },
  //         sortable: !0,
  //         pagination: !0,
  //         toolbar: {
  //             items: {
  //                 pagination: {
  //                     pageSizeSelect: [10, 20, 30, 50, 100]
  //                 }
  //             }
  //         },
  //         search: {
  //             onChange: true,
  //             input: $('#SearchValue'),
  //             delay: 400,
  //         },
  //         rows: {
  //             afterTemplate: function (row, data, index) {
  //                 $(row).find(".btnEditDriver").click(function () {
  //                     var Id = $(this).attr("Id");
  //                     DashboardComponent.dashbaordComponent.router.navigate(['/Driver', Id]);
  //                 });
  //             },
  //         },
  //         columns: [
  //             {
  //                 field: "DriverName", width: 250, title: "Driver", sortable: !1, overflow: "visible",
  //                 template: function (t) {
  //                     var btn = "";
  //                     if (DashboardComponent.dashbaordComponent.commonService.CheckHasRight("EDIT", "DRIVERS_DETAILS")) {
  //                         var btn = '<a id="' + t.Id + '" style="cursor:pointer;"  class="btnEditDriver" title="Edit details">' + t.DriverName + '</a>'
  //                     }
  //                     else {
  //                         var btn = '<span>' + t.DriverName + '</span>'
  //                     }
  //                     return btn;
  //                 }
  //             },
  //             {
  //                 field: 'TransporterName', title: "Network", sortable: true, width: 200, textAlign: 'left'
  //             },
  //             {
  //                 field: 'CreatedDate', title: "Created On", sortable: true, width: 100, textAlign: 'right'
  //             },

  //         ]
  //     });
  // }

  // GetLocationCodeList() {
  //     this.Locationdatatable = (<any>$('.m_datatable_LocationCode')).mDatatable({
  //         data: {
  //             type: "remote",
  //             source: {
  //                 read: {
  //                     method: 'POST',
  //                     url: environment.apiUrl + "api/Dashboard/GetDashboardLocationCodeList",
  //                     params: {
  //                         // custom parameters
  //                         CompanyId: DashboardComponent.dashbaordComponent.CompanyId,
  //                         DateFilterValue: DashboardComponent.dashbaordComponent.DashboardSearchData.DateFilterValue,
  //                         DateFilterName: DashboardComponent.dashbaordComponent.DashboardSearchData.DateFilterName
  //                     },
  //                 }
  //             },
  //             pageSize: 10,
  //             serverPaging: !0,
  //             serverFiltering: !0,
  //         },
  //         layout: {
  //             class: 'm--margin-top-5',
  //             scroll: false,
  //             footer: !1,
  //             smoothScroll: {
  //                 scrollbarShown: true
  //             }
  //         },
  //         sortable: !0,
  //         pagination: !0,
  //         toolbar: {
  //             items: {
  //                 pagination: {
  //                     pageSizeSelect: [10, 20, 30, 50, 100]
  //                 }
  //             }
  //         },
  //         search: {
  //             onChange: true,
  //             input: $('#SearchValue'),
  //             delay: 400,
  //         },
  //         rows: {
  //             afterTemplate: function (row, data, index) {
  //                 $(row).find(".btnEditLocation").click(function () {
  //                     var Id = $(this).attr("Id");
  //                     DashboardComponent.dashbaordComponent.router.navigate(['/network', Id]);
  //                 });
  //             },
  //         },
  //         columns: [
  //             {
  //                 field: "CustomerName", width: 250, title: "Customer", sortable: !1, overflow: "visible",
  //                 template: function (t) {
  //                     var btn = "";
  //                     if (DashboardComponent.dashbaordComponent.commonService.CheckHasRight("VIEW", "NETWORK_DETAILS")) {
  //                         btn = `<a id="${t.Id}" class="btnEditLocation" style="cursor:pointer;">${t.CustomerName}</a>`;
  //                     } else {
  //                         btn = `<span id="${t.Id}">${t.CustomerName}</span>`;
  //                     }
  //                     return btn;
  //                 }
  //             },
  //             {
  //                 field: 'DeliveryLocationCode', title: "Delivery Location Code", sortable: true, width: 200, textAlign: 'left'
  //             }]
  //     });
  // }
}
